import { InjectionToken, Signal } from '@angular/core';

export type FormPageHeadingMode =
  | 'creating'
  | 'editing'
  | 'performing'
  | 'renewing'
  | 'signingOff'
  | 'validating';

// Expose the header's signal without a circular header/heading component import.
export const FORM_PAGE_HEADER_MODE = new InjectionToken<Signal<FormPageHeadingMode | null>>(
  'FormPageHeaderMode'
);
